<template>
	<div class="box">
        
        <el-aside style="height: 100%;width: 100%;"> <MenuIndex/></el-aside>
        <el-main><router-view/></el-main>
	</div>

</template> 

<script>
import {Form, Message} from 'element-ui';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import MenuIndex from '../views/chatgpt/menu_index.vue';

export default{

name:"Chatgpt",
    components: {MenuIndex},
    data(){
        return {
            title:"人工智能",
            socket:null,
            stompClient:null
        }
    },
    methods:{
		handleClick(tab, event) {
			console.log(tab, event);
		},
   
        //初始化
            initWebSocket(){
                
                this.connection();

            },
            //建立连接
            connection() {
                // 建立连接对象
                //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
                let _that=this;
                //后台服务ip和porthttps://apitest.hooply.com
                _that.socket = new SockJS('http://localhost:8001/ws/ep?token=asdf');
              //_that.socket = new SockJS('https://apitest.hooply.com/ws/ep');
                // 获取STOMP子协议的客户端对象
                _that.stompClient = Stomp.over(_that.socket);
                 _that.stompClient.debug = null 

            // _that.stompClient.connect({"user":"1001",'type':1}, success => {
                _that.stompClient.connect({"token":"1001",'type':1}, success => {
                    _that.stompClient.subscribe('/user/queue/chat', msg => {
                        console.log("msg:",msg)
                        let receiveMsg = JSON.parse(msg.body);
                    
                        console.log("receiveMsg："+JSON.stringify(receiveMsg))
                    
                    })
                }, error => {

                });
            },
            disconnect() {
                if (this.stompClient != null) {
                    this.stompClient.disconnect();
                 
                }
            },
       
        //销毁页面之前，断开连接
        beforeDestroy: function () {
            //页面离开时断开连接,清除定时器
            //this.disconnect();
            clearInterval(this.timer);
        },
        mounted(){
            //调用初始化websocket方法
    
        },
       
        addMessage() {
               
                    let msgObj = new Object();
                    msgObj.toUserId =  this.phone;
                  //  msgObj.fromUserPhone = 18313975762;
                    msgObj.chatMsg = this.content;
                  
                    this.stompClient.send('/ws/chat', {}, JSON.stringify(msgObj));
             
            },
             //getMsg(){
            //    this.stompClient.subscribe('/user/queue/chat', msg => {
            //        let receiveMsg = JSON.parse(msg.data);
                   
             //       console.log("receiveMsg："+receiveMsg)
          //  })
       // },
        detail(){
             this.postRequest('/user/info',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                  window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                  console.log("this.username:"+this.username);
            })
        },
        loginAnonymous(){
             this.postRequest('/user/login_anonymous',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                console.log("this.username:"+this.username);
                console.log("resp.error:"+resp.err);
                if(resp.err === 0){
                    this.initWebSocket();
                }
                  
            })
        }
    },
    
    created() {
      //  this.loginAnonymous();
      //this.initWebSocket();
     // window.localStorage.setItem('aaa',2)
    //this.userId = window.localStorage.getItem('aaa');
    },
    //destroyed() {
      //this.websock.close();//离开路由之后断开websocket连接
    //}
}
</script>
<style>
	.box{

       
      /* 水平垂直居中 */
      margin: 10px 80px auto;

	}
</style>